import React from 'react';
import userImage from '../../../assets/img/dating-imgs/dating-userpic1.png';
import './BioInformation.css';
const BioInformation = () => {
    const bioInformations =[
        {
            canditaedName: 'Maruf',
            canditaedAge: '35',
            activeStatus: '12 mi',
            shortBio : '"Lorem ipsum dolor sit amet, consect etur adipiscing elit. Quisque ac..."',
        },
        {
            canditaedName: 'Mobin',
            canditaedAge: '15',
            activeStatus: '15 mi',
            shortBio : '"Lorem ipsum dolor sit amet, consect etur adipiscing elit. Quisque ac..."',
        },
        {
            canditaedName: 'Haider',
            canditaedAge: '25',
            activeStatus: '17 mi',
            shortBio : '"Lorem ipsum dolor sit amet, consect etur adipiscing elit. Quisque ac..."',
        },
        {
            canditaedName: 'Faruk',
            canditaedAge: '14',
            activeStatus: '16 mi',
            shortBio : '"Lorem ipsum dolor sit amet, consect etur adipiscing elit. Quisque ac..."',
        },
        {
            canditaedName: 'Richa',
            canditaedAge: '41',
            activeStatus: '14 mi',
            shortBio : '"Lorem ipsum dolor sit amet, consect etur adipiscing elit. Quisque ac..."',
        },
    ]   
    return (
        <div className="row g-4">
            {
                bioInformations.map( (item, index) =>  <div className="col-12 col-md-6 col-xxl-4" key={index}>
                <div className="card" style={{backgroundColor: "#171717", borderRadius: "20px",borderStyle: "none"}}>
                    <div>
                        <img className="w-100" src={userImage} style={{borderRadius: "20px 20px 0px 0px"}} alt='' />
                        </div>
                    <div className="card-body card-design">
                        <div className="row gap-2">
                            <div className="col-12 d-flex justify-content-between align-items-center">
                                <div>
                                    <span className="dating_h me-1">{item.canditaedName}</span>
                                    <span className="grp_mem">{item.canditaedAge}</span>
                                </div>
                                <span className="e_bdt">{item.activeStatus}</span>
                            </div>
                            <div className="col-12">
                                <p className="mb-0 dating_para">
                                    {item.shortBio}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>)
               
            }
        </div>
    );
};

export default BioInformation;